export default __webpack_public_path__ + "static/media/insuranceCare.4e417e79.svg";